import React from 'react'
import CollapseMethods from './collapse.local.methods'
import Icon from 'blocks.simple/icon/icon'
import Measure from 'react-measure'
import { cn } from 'ethcss'
import rawStyles from './collapse.jcss'
import { textSizes } from 'blocks.app/config'
import { CollapseDefaultProps, CollapseProps } from './collapse.types'

const styles = (rawStyles as unknown) as Record<string, string>

const Collapse = (p_: CollapseProps) => {
    const { open, withoutOverflow, dimensions, onClick, updateDimensions, contentOpen, contentClose } = CollapseMethods(
        p_
    )
    const getWrapperClassNames = (showContent: boolean) => {
        const { className, activeClassName } = p_

        return showContent ? cn(styles.wrapper, className, activeClassName) : cn(styles.wrapper, className)
    }

    const getTitleClassNames = (showContent: boolean) => {
        const { titleClassName, titleActiveClassName } = p_

        return showContent
            ? cn({ [styles.noWrap]: p_.noWrap }, styles.title, titleClassName, titleActiveClassName)
            : cn({ [styles.noWrap]: p_.noWrap }, styles.title, titleClassName)
    }

    const showContent = open && p_.isLoaded
    const height = dimensions ? dimensions.height : 0

    if (p_.refObj) {
        p_.refObj.onClick = onClick
        p_.refObj.contentOpen = contentOpen
        p_.refObj.contentClose = contentClose
    }

    return (
        <div className={getWrapperClassNames(showContent)}>
            <div
                className={getTitleClassNames(showContent)}
                onClick={onClick}
                onMouseOver={p_.onMouseOver}
                onMouseOut={p_.onMouseOut}
            >
                <span className={styles.titleWrapper}>
                    {p_.titleAsBlock ? p_.titleAsBlock() : p_.title({ open: open })}
                </span>
                {p_.showArrow && !p_.disabled && (
                    <Icon size={textSizes.normal} type={open ? 'arrow_up' : 'arrow_down'} {...p_.toggleIconOptions} />
                )}
            </div>
            <div
                className={cn(styles.contentWrapper, p_.contentWrapperClassName, {
                    [styles.withoutOverflow]: withoutOverflow && showContent,
                })}
                style={{ maxHeight: showContent ? `${height}px` : `0px` }}
            >
                <Measure
                    bounds
                    onResize={(contentRect) => {
                        updateDimensions(contentRect.bounds)
                    }}
                >
                    {({ measureRef }) => (
                        <div
                            className={cn({ [styles.content]: p_.contentPadding }, p_.contentClassName)}
                            ref={measureRef}
                        >
                            {p_.children}
                        </div>
                    )}
                </Measure>
            </div>
        </div>
    )
}

const defaultProps: CollapseDefaultProps = {
    isLoaded: true,
    contentPadding: true,
    showArrow: true,
    withoutOverflow: false,
    onToggle: () => {},
    activeClassName: '',
    titleActiveClassName: '',
}

Collapse.defaultProps = defaultProps

export default Collapse
